import React, { useState } from 'react';
import { AddToClipBoard } from './../../utils/functions';

function CopyButton({ value }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    AddToClipBoard(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const [hovered, setHovered] = useState(false);

  return (
    <span
      className="material-symbols-rounded"
      onClick={handleCopy}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      title={copied ? 'Copied!' : 'Copy'}
      style={{
        fontSize: '14px',
        cursor: 'pointer',
        color: copied ? '#006E85' : hovered ? '#006E85' : 'rgba(0,0,0,0.35)',
        marginLeft: '4px',
        verticalAlign: 'middle',
        transition: 'color 0.15s ease, background-color 0.15s ease',
        userSelect: 'none',
        borderRadius: '4px',
        padding: '2px',
        backgroundColor: hovered || copied ? 'rgba(0, 110, 133, 0.07)' : 'transparent',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {copied ? 'check' : 'content_copy'}
    </span>
  );
}

export default function ColorSquare({ color }) {
  let name, clr, pantone, cmyk;
  clr = color;
  if (color.name) {
    name = color.name;
  }
  if (color.hex) {
    clr = color.hex;
  }
  if (color.pantone) {
    pantone = color.pantone;
  }
  if (color.cmyk) {
    cmyk = color.cmyk;
  }
  if (clr) {
    clr = clr.toLowerCase();
  }

  return (
    <div className="tiny-padding" style={{ maxWidth: '300px', paddingLeft: '0px' }}>
      <div className="white-background shadow" style={{ borderRadius: '4px', overflow: 'hidden' }}>
        <img className="full-width" src="/images/square.png" style={{ backgroundColor: clr }} />
        <div className="tiny-padding" style={{ minWidth: 110 }}>
          {name && (
            <p>
              <b>{name}</b>
            </p>
          )}
          {clr && (
            <div style={{ paddingTop: '8px' }}>
              <h6 style={{ display: 'flex', alignItems: 'center' }}>
                <b className="subheading">{'HEX'}</b>
                <CopyButton value={clr} />
              </h6>
              <p className="subheading uppercase">{clr}</p>
            </div>
          )}
          {pantone && (
            <div style={{ paddingTop: '8px' }}>
              <h6 style={{ display: 'flex', alignItems: 'center' }}>
                <b className="subheading">{'PANTONE'}</b>
                <CopyButton value={pantone} />
              </h6>
              <p className="subheading">{pantone}</p>
            </div>
          )}
          {cmyk && (
            <div style={{ paddingTop: '8px' }}>
              <h6 style={{ display: 'flex', alignItems: 'center' }}>
                <b className="subheading">{'CMYK'}</b>
                <CopyButton value={cmyk} />
              </h6>
              <p className="subheading">{cmyk}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
